import api from '../../../services/Api';
import { IAuditoriaCashRichResultado } from '../interfaces/IAuditoriaCashRich';

interface BuscarParams {
  empresaId: number;
  periodo?: string;
}

const resultadoVazio: IAuditoriaCashRichResultado = {
  impactoFinanceiroTotal: 0,
  impactoFiscalTotal: 0,
  totalErros: 0,
  totalAlertas: 0,
  totalAvisos: 0,
  status: 'CONCILIADO',
  mensagemDirecionamento: '',
  fundamentacaoLegal: '',
  itens: [],
};

export const AuditoriaCashRichService = {
  async buscarResultado(params: BuscarParams): Promise<IAuditoriaCashRichResultado> {
    const response = await api.get<IAuditoriaCashRichResultado>(
      'auditoria-cash-rich/resultado',
      { params: { empresaIds: params.empresaId, periodo: params.periodo || '' } }
    );
    return response.data || resultadoVazio;
  },
};
